import React from "react";
import "./change-password.styles.css";
import { Button, Form, Icon, Input, Modal, Typography, message } from "antd";
import API from "../../api";
import { encrypt } from "../../services/generic-apis";
import { SignOutAPI } from "../../auth/utils";
import { setScreen } from "../../redux/commodity-intelegence-tower/commodity-intelegence-tower.actions";
import {
  setAccessToken,
  setRefreshToken,
  setUserLoggedStatus,
} from "../../redux/user/user.actions";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import { withRouter } from "react-router-dom";
import { selectUserData } from "../../redux/user/user.selectors";

class ChangePasswordForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      confirmDirty: false,
    };
  }

  componentDidUpdate() {
    !this.props.open && this.props.form.resetFields();
  }

  passwordValidator = (rule, value, callback) => {
    if (value && value.trim().length < 8) {
      callback("Password must be at least 8 characters.");
    } else if (value && !value.match(/[a-z]/)) {
      callback("Password must contain at least one lowercase letter.");
    } else if (value && !value.match(/[A-Z]/)) {
      callback("Password must contain at least one uppercase letter.");
    } else if (value && !value.match(/[0-9]/)) {
      callback("Password must contain at least one digit.");
    } else if (value && !value.match(/[^a-zA-Z0-9]/)) {
      callback("Password must contain at least one special character.");
    } else callback();
  };

  handleSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        API.put(
          "changepassword",
          {
            user_name: encrypt(this.props.userName),
            old_password: encrypt(values.oldPassword),
            new_password: encrypt(values.newPassword),
          },
          {}
        )
          .then((response) => {
            if (response.status) {
              this.handleClose();
              try {
                SignOutAPI();
                this.props.setAccessToken(null);
                this.props.setRefreshToken(null);
                this.props.setUserLoggedStatus(false);
                this.props.setScreen(0);
              } catch (error) {
                console.log(error);
                message.error("Something went wrong, please try again.");
              }
              // this.props.submit({
              //   username: this.props.userName,
              //   password: values.newPassword,
              // });
            } else {
              message.error("Something went wrong, please try again.");
            }
          })
          .catch((err) => {
            if (err.response) message.error(err.response.data.msg);
            else message.error("Something went wrong, please try again.");
          });
      }
    });
  };

  compareToFirstPassword = (rule, value, callback) => {
    const { form } = this.props;
    if (value && value !== form.getFieldValue("newPassword")) {
      callback("Please input similar new and confirm passwords!");
    } else callback();
  };

  validateToNextPassword = (rule, value, callback) => {
    const { form } = this.props;
    if (value && this.state.confirmDirty) {
      form.validateFields(["confirmPassword"], { force: true });
    }
    this.passwordValidator(rule, value, callback);
  };

  handleConfirmBlur = (e) => {
    const { value } = e.target;
    this.setState({ confirmDirty: this.state.confirmDirty || !!value });
  };

  handleClose = () => this.props.setClose();

  render() {
    const { getFieldDecorator } = this.props.form;
    return (
      <Modal
        title={<div style={{ textAlign: "center" }}>Change Password</div>}
        visible={this.props.open}
        keyboard={false}
        maskClosable={false}
        closable={false}
        footer={null}
        onCancel={this.handleClose}
        centered
        width={330}
      >
        <Typography.Text strong>
          Password expired. Please change your password.
        </Typography.Text>
        <Form
          className="modal-input"
          onSubmit={this.handleSubmit}
          autoComplete="off"
        >
          <Form.Item>
            {getFieldDecorator("oldPassword", {
              rules: [
                {
                  required: true,
                  message: "Please input Old Password (OTP)!",
                },
              ],
            })(
              <Input.Password
                size="large"
                prefix={
                  <Icon type="lock" style={{ color: "rgba(0,0,0,.25)" }} />
                }
                placeholder="Old Password"
              />
            )}
          </Form.Item>
          <Form.Item>
            {getFieldDecorator("newPassword", {
              rules: [
                {
                  required: true,
                  message: "Please input your new password!",
                },
                {
                  validator: this.validateToNextPassword,
                },
              ],
            })(
              <Input.Password
                size="large"
                prefix={
                  <Icon type="lock" style={{ color: "rgba(0,0,0,.25)" }} />
                }
                placeholder="New Password"
              />
            )}
          </Form.Item>
          <Form.Item>
            {getFieldDecorator("confirmPassword", {
              rules: [
                {
                  required: true,
                  message: "Please input your confirm password!",
                },
                {
                  validator: this.compareToFirstPassword,
                },
              ],
            })(
              <Input.Password
                size="large"
                onBlur={this.handleConfirmBlur}
                prefix={
                  <Icon type="lock" style={{ color: "rgba(0,0,0,.25)" }} />
                }
                placeholder="Confirm Password"
              />
            )}
          </Form.Item>
          <Form.Item>
            <Button type="primary" htmlType="submit">
              Change Password
            </Button>
          </Form.Item>
        </Form>
      </Modal>
    );
  }
}

const ChangePassword = Form.create({ name: "change_password" })(
  ChangePasswordForm
);

const mapStateToProps = createStructuredSelector({
  userData: selectUserData,
});

const mapDispatchToProps = (dispatch) => {
  return {
    setScreen: (data) => dispatch(setScreen(data)),
    setAccessToken: (token) => dispatch(setAccessToken(token)),
    setRefreshToken: (token) => dispatch(setRefreshToken(token)),
    setUserLoggedStatus: (status) => dispatch(setUserLoggedStatus(status)),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ChangePassword)
);
